import AdminService from "@/services/AdminService";

export default {

    addAction: async (action) => {
        await AdminService.addAction(action);
    }
};
